import { AppService, APP_MODE } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { WorkflowOnlineService } from './workflow-online.service';
import { WorkflowOfflineService } from './workflow-offline.service';
import { WorkflowService } from './workflow.service';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';

const WorkflowServiceFactory = (appService: AppService, httpClient: HttpClient, apiService: ApiService, unitOfWork: UnitOfWorkOfflineDao) =>
    appService.AppMode == APP_MODE.ONLINE_MODE ? 
    new WorkflowOnlineService(httpClient, apiService) : new WorkflowOfflineService(unitOfWork, httpClient);

export const WorkflowServiceProvider = { 
    provide: WorkflowService,
    useFactory: WorkflowServiceFactory,
    deps: [AppService, HttpClient, ApiService, UnitOfWorkOfflineDao]
};